import debug from 'bows';

const log = debug('bows');

export default class {
	constructor( node, opts ) {
		this.node = ( typeof node === 'string' ) ? document.querySelector(node) : node;
		this.opts = Object.assign( {
			activeClass: 'tabs--active',
			activeTabClass: 'tab--active',
			activeNavClass: 'tabs__nav--active',
			tabs: '.tab',
			navs: '.tabs nav button'
		}, opts );


		this.tabs = Array.from( this.node.querySelectorAll( this.opts.tabs ) );
		this.navs = Array.from( this.node.querySelectorAll( this.opts.navs ) ).map( ( nav, index ) => {
			nav.addEventListener( 'click', (e) => {
				if ( e && e.preventDefault ) {
					e.preventDefault();
				}

				this.goTo(index);
			});

			return nav;
		} );

		this.node.classList.add(this.opts.activeClass);

		this.active = -1;
		this.goTo(0);

		this.node.dispatchEvent( new CustomEvent( 'tabs.init', this ) );
		log(this);
	}

	goTo(index) {
		if ( this.active > -1 ) {
			this.tabs[this.active].classList.remove(this.opts.activeTabClass);
			this.navs[this.active].classList.remove(this.opts.activeNavClass);
		}

		this.active = index;

		this.tabs[this.active].classList.add(this.opts.activeTabClass);
		this.navs[this.active].classList.add(this.opts.activeNavClass);

		this.node.dispatchEvent( new CustomEvent( 'tabs.goTo', this ) );
	}
}
